import { LitElement } from "lit-element";
import "./_nav-controller.scss";
class NavController extends LitElement {
	static get properties() {
		return {
			title: { type: String },
		};
	}

	constructor() {
		super();
		this.navItems = null;
		this.currentURL = null;
		this.isInnerPage = false;
		this.selectedItem = null;
		this.nextBtn = null;
		this.prevBtn = null;
	}

	connectedCallback() {
		super.connectedCallback();
		this.navItems = this.querySelectorAll("a");
		this.currentURL = window.location.href;
		this.setActiveNavItem();

		this.nextBtn = this.querySelector(".nav-button-right");
		this.nextBtn.addEventListener("click", () => {
			this.nextItem();
		});
		this.prevBtn = this.querySelector(".nav-button-left");
		this.prevBtn.addEventListener("click", () => {
			this.prevItem();
		});

		if (window.location.pathname === "/" && window.location.hash === "") {
			this.hideNav();
		} else {
			this.showNav();
		}

		// if #footer enters 50% of the viewport hide the nav
		const footer = document.querySelector("#footer");

		if (footer) {
			const footerObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.hideNav();
					} else {
						this.showNav();
					}
				});
			});
			footerObserver.observe(footer);
		}
		// window.onpopstate(() => {
		// 	console.log("Heellllooo");
		// 	this.setActiveNavItem();
		// 	console.log("we changed");
		//
		// 	if (window.location.pathname === "/" && window.location.hash === null) {
		// 		this.hideNav();
		// 	} else {
		// 		this.showNav();
		// 	}
		// });

		// Add a windowEventListener for each nav item
		this.navItems.forEach((item) => {
			item.addEventListener("click", () => {
				this.setActiveNavItem();
			});
		});
	}

	setActiveNavItem() {
		if (window.location.pathname === "/") {
			console.log(window.location.hash);
			if (!window.location.hash || window.location.hash === "#intro") {
				this.hideNav();
			} else {
				this.showNav();
			}
		}

		if (this.selectedItem) {
			this.selectedItem.classList.remove("active");
			this.selectedItem.parentNode.classList.remove("active");

			// Check if this selectedItem has a sibling before or after
			// if it does, remove the disabled class from the nav buttons
			if (this.selectedItem.parentNode.nextElementSibling) {
				this.nextBtn.classList.remove("disabled");
			} else {
				this.nextBtn.classList.add("disabled");
			}

			if (this.selectedItem.parentNode.previousElementSibling) {
				this.prevBtn.classList.remove("disabled");
			} else {
				this.prevBtn.classList.add("disabled");
			}
		}

		this.navItems.forEach((item) => {
			const name = item.getAttribute("data-name");
			//nsole.log(name);
			//console.log(window.location.hash);
			// Check to see if the window.location.pathname matches a substring in item.href
			if (window.location.hash !== "") {
				if (window.location.hash.includes(name)) {
					item.classList.add("active");
					// Get the parent node
					item.parentNode.classList.add("active");
					this.selectedItem = item;
				}
			} else if (window.location.href.includes(name)) {
				item.classList.add("active");
				item.parentNode.classList.add("active");
				this.selectedItem = item;
			} else {
				item.classList.remove("active");
				item.parentNode.classList.remove("active");
			}
		});
	}

	nextItem() {
		const nextItem = this.selectedItem.parentNode.nextElementSibling;
		if (nextItem) {
			nextItem.querySelector("a").click();
		}
	}

	prevItem() {
		const prevItem = this.selectedItem.parentNode.previousElementSibling;
		if (prevItem) {
			prevItem.querySelector("a").click();
		}
	}

	showNav() {
		this.classList.add("show");
	}

	hideNav() {
		this.classList.remove("show");
	}

	removeFrontSlash() {
		this.navItems.forEach((item) => {
			// replace only the first "/" with an empty string
			item.href = item.href.replace("/", "");
		});
	}

	createRenderRoot() {
		return this;
	}
}

window.customElements.define("nav-controller", NavController);
